<div
  [class]="layout.config.settings.layout_version"
  [ngClass]="{ 'has-banner': showBanner, 'demo-mode': isDemoMode, 'has-multiple-banners': multipleBanners }"
>
  <div [ngClass]="layout.config.settings.sidebar" class="page-wrapper" id="canvas-bookmark">
    <div
      (scroll)="scrollHandler()"
      [class.close_icon]="navServices.collapseSidebar"
      [ngStyle]="{ display: show ? 'block' : 'none' }"
      class="page-header"
    >
      <app-banner #banner></app-banner>
      <app-header></app-header>
    </div>
    <div [class.scorlled]="Scorlled && !show" class="page-body-wrapper">
      <div
        [attr.sidebar-layout]="layout.config.settings.sidebar_type"
        [class.close_icon]="navServices.collapseSidebar"
        class="sidebar-wrapper m-hide-below-lg"
      >
        <app-sidebar></app-sidebar>
      </div>
      <div [@routeAnimations]="prepareRoute(outlet)" class="page-body pt-3">
        <router-outlet #outlet="outlet"></router-outlet>
      </div>
      <div
        [class.footer-dark]="footerDark"
        [class.footer-fix]="footerFix"
        [class.footer-light]="footerLight"
        class="footer mt-4"
      >
        <app-footer></app-footer>
      </div>
    </div>
  </div>
  @if (!tiktokAuthorized()) {
    <app-modal-connect-tiktok></app-modal-connect-tiktok>
  }
</div>
